export const TRANSACTIONS_FETCH = 'TRANSACTIONS_FETCH';
export const TRANSACTIONS_IS_FETCING = 'TRANSACTIONS_IS_FETCING';
export const TRANSACTIONS_API = 'transactions';
export const TRANSACTION_EDIT = 'TRANSACTION_EDIT';
export const TRANSACTION_SAVE = 'TRANSACTION_SAVE';
export const TRANSACTION_FILTER = 'TRANSACTION_FILTER';
export const SET_TRANSACTION_VIEW_FILTER = 'SET_TRANSACTION_VIEW_FILTER';
export const UPDATE_TRANSACTION_STATUS = 'UPDATE_TRANSACTION_STATUS';



// WEBPACK FOOTER //
// ./src/constants/transactions.js